import moment from 'moment'
import { z } from 'zod'

import {
  DurationUnitName,
  DurationWithSingleUnit
} from '@/modules/shared/schemas/Duration'

export const TicketPriority = z.enum(['UNDEFINED', 'LOW', 'MEDIUM', 'HIGH'])
export type TicketPriority = z.infer<typeof TicketPriority>

export const TicketPriorityFilter = z.enum(['ALL', ...TicketPriority.options])
export type TicketPriorityFilter = z.infer<typeof TicketPriorityFilter>

export const SlaConfiguration = z.enum(['TME', 'TMA'])

export const AreaPriorities = z.object({
  id: z.string(),
  time: z.string().duration().nullable(),
  priority: TicketPriority.exclude(['UNDEFINED']).nullable(),
  slaConfiguration: SlaConfiguration
})
export type AreaPriorities = z.infer<typeof AreaPriorities>

export const AreaPrioritiesList = AreaPriorities.array()
export type AreaPrioritiesList = z.infer<typeof AreaPrioritiesList>

export const UpdateAreaPriorityDTO = z
  .object({
    time: z.string().duration(),
    priority: TicketPriority.exclude(['UNDEFINED']).nullable(),
    slaConfiguration: SlaConfiguration
  })
  .array()
export type UpdateAreaPriorityDTO = z.infer<typeof UpdateAreaPriorityDTO>

export const UpdateAreaPriorityForm = z.record(
  z.enum([
    SlaConfiguration.enum.TME,
    ...TicketPriority.exclude(['UNDEFINED']).options.map(
      (priority) => `${SlaConfiguration.enum.TMA}-${priority}` as const
    )
  ]),
  DurationWithSingleUnit
)
export type UpdateAreaPriorityForm = z.infer<typeof UpdateAreaPriorityForm>

export const UpdateAreaPriorityFromFormToUpdate =
  UpdateAreaPriorityForm.transform((data): UpdateAreaPriorityDTO => {
    const updateAreaPriorityList: UpdateAreaPriorityDTO = []

    if (data.TME?.value && data.TME) {
      updateAreaPriorityList.push({
        time: moment
          .duration(
            data.TME.value,
            data.TME.unit.toLowerCase() as Lowercase<DurationUnitName>
          )
          .toISOString(),
        priority: null,
        slaConfiguration: 'TME'
      })
    }

    if (data['TMA-HIGH']?.value && data['TMA-HIGH']) {
      updateAreaPriorityList.push({
        time: moment
          .duration(
            data['TMA-HIGH'].value,
            data['TMA-HIGH'].unit.toLowerCase() as Lowercase<DurationUnitName>
          )
          .toISOString(),
        priority: 'HIGH',
        slaConfiguration: 'TMA'
      })
    }

    if (data['TMA-MEDIUM']?.value && data['TMA-MEDIUM']) {
      updateAreaPriorityList.push({
        time: moment
          .duration(
            data['TMA-MEDIUM'].value,
            data['TMA-MEDIUM'].unit.toLowerCase() as Lowercase<DurationUnitName>
          )
          .toISOString(),
        priority: 'MEDIUM',
        slaConfiguration: 'TMA'
      })
    }

    if (data['TMA-LOW']?.value && data['TMA-LOW']) {
      updateAreaPriorityList.push({
        time: moment
          .duration(
            data['TMA-LOW'].value,
            data['TMA-LOW'].unit.toLowerCase() as Lowercase<DurationUnitName>
          )
          .toISOString(),
        priority: 'LOW',
        slaConfiguration: 'TMA'
      })
    }
    return updateAreaPriorityList
  })
